<p-confirmDialog appendTo="body"></p-confirmDialog>

<div class="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 shadow-sm w-full">

  <!-- Lado Izquierdo: Toggle + Título -->
  <div class="flex items-center gap-3">
    <button
      pButton
      type="button"
      [icon]="sidebarVisible ? 'pi pi-angle-left' : 'pi pi-angle-right'"
      class="p-button-text p-button-rounded text-gray-600 w-10 h-10 hover:bg-gray-100"
      (click)="toggleSidebar.emit()"
      pTooltip="Alternar Menú">
    </button>

    <h1 class="text-lg font-semibold text-gray-800 m-0">
      {{ currentTitle() }}
    </h1>
  </div>

  <!-- Lado Derecho: Notificaciones + Info Usuario -->
  <div class="flex items-center gap-3">

    <!-- Botón Notificaciones -->
    <button
      pButton
      icon="pi pi-bell"
      class="p-button-text p-button-rounded p-button-secondary w-10 h-10 text-gray-500 hover:bg-gray-100"
      [routerLink]="['/charger-notifications']">
    </button>
    @if(hasUnreadNotification()) {
      <p-overlaybadge 
        [value]="unreadCount()" 
        severity="danger"
        badgeSize="small"
        class="relative -top-3.5 right-3.5">
      </p-overlaybadge>
    }

    <!-- Sección Usuario (Avatar + Texto) -->
    <div class="flex items-center gap-3 cursor-pointer p-1.5 rounded-lg hover:bg-gray-50 transition-colors"
         (click)="userMenu.toggle($event)">

      <!-- 1. Avatar -->
      <p-avatar
        [label]="userInitial()"
        shape="circle"
        class="text-white font-bold text-sm shadow-sm"
        [style]="{'background-color': 'var(--primary-color)', 'color': '#ffffff', 'width': '36px', 'height': '36px'}">
      </p-avatar>

      <!-- 2. Información Texto -->
      <div class="hidden md:flex flex-col items-start">
        <span class="text-sm font-semibold text-gray-700 leading-tight">
          {{ currentUser()?.name }}
        </span>
        <span class="text-xs text-gray-500 font-medium">
          {{ currentUser()?.role?.name || 'Sin Rol' }}
        </span>
      </div>

    </div>

    <!-- Menú popup -->
    <p-menu #userMenu [model]="userMenuItems" [popup]="true" appendTo="body"></p-menu>
  </div>
</div>
